import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

import ChevronBottomIcon from "../../assets/imgs/chevron-bottom-icon.svg";

const VisitDateDropdown = ({
  ariaLabel,
  value,
  options = [],
  onChange,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((option) => option.value === value);
  const selectedLabel = selectedOption?.label || "—";

  return (
    <Dropdown
      show={isOpen}
      onToggle={(nextOpen) => setIsOpen(nextOpen)}
      align="end"
    >
      <button
        type="button"
        className={`anthropometry-detailed-progress__visit-range__trigger${
          isOpen ? " anthropometry-detailed-progress__visit-range__trigger--active" : ""
        }`}
        aria-label={ariaLabel}
        disabled={disabled || options.length === 0}
        onClick={() => setIsOpen((current) => !current)}
      >
        <span>{selectedLabel}</span>
        <img src={ChevronBottomIcon} alt="" />
      </button>
      <Dropdown.Menu className="anthropometry-detailed-progress__visit-range__menu">
        {options.map((option) => (
          <Dropdown.Item
            key={option.value}
            as="button"
            className={`anthropometry-detailed-progress__visit-range__option${
              option.value === value
                ? " anthropometry-detailed-progress__visit-range__option--selected"
                : ""
            }`}
            onClick={() => {
              onChange(option.value);
              setIsOpen(false);
            }}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const MuscleDetailDateRange = ({
  startOptions = [],
  endOptions = [],
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => (
  <div className="anthropometry-detailed-progress__visit-range">
    <span className="anthropometry-detailed-progress__visit-range__label">Período</span>
    <VisitDateDropdown
      ariaLabel="Data inicial do período"
      value={startDate}
      options={startOptions}
      onChange={onStartDateChange}
    />
    <span className="anthropometry-detailed-progress__visit-range__separator">até</span>
    <VisitDateDropdown
      ariaLabel="Data final do período"
      value={endDate}
      options={endOptions}
      onChange={onEndDateChange}
    />
  </div>
);

export default MuscleDetailDateRange;
